import { PasswordCard } from '../components/PasswordCard';

export function PasswordSection() {
  return <PasswordCard />;
}
